import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { Zap, Mail, Lock, ArrowRight } from 'lucide-react';

export default function Login() {
  const { login } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success('Welcome back!');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:'2rem', backgroundImage:'radial-gradient(ellipse at 50% 0%, rgba(108,71,255,0.12) 0%, transparent 60%)' }}>
      <div style={{ width:'100%', maxWidth:400 }}>
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <div style={{ width:48, height:48, background:'linear-gradient(135deg,#6c47ff,#4f46e5)', borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', boxShadow:'0 0 30px rgba(108,71,255,.3)' }}>
            <Zap size={22} color="white" fill="white" />
          </div>
          <h1 style={{ fontSize:24, fontWeight:800, letterSpacing:'-.03em' }}>Welcome back</h1>
          <p style={{ color:'var(--muted)', marginTop:6, fontSize:14 }}>Sign in to ColdCraft AI</p>
        </div>

        <div className="card" style={{ padding:28 }}>
          <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:16 }}>
            {[
              { key:'email', label:'Email', type:'email', placeholder:'you@company.com', Icon:Mail },
              { key:'password', label:'Password', type:'password', placeholder:'••••••••', Icon:Lock },
            ].map(({ key, label, type, placeholder, Icon }) => (
              <div key={key}>
                <label style={{ display:'block', fontSize:12, fontWeight:600, marginBottom:6, color:'var(--muted)' }}>{label}</label>
                <div style={{ position:'relative' }}>
                  <Icon size={14} style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'var(--muted)' }} />
                  <input className="input" type={type} placeholder={placeholder} value={form[key]}
                    onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
                    style={{ paddingLeft:34 }} required />
                </div>
              </div>
            ))}
            <button type="submit" className="btn btn-primary" disabled={loading} style={{ width:'100%', justifyContent:'center', padding:'11px' }}>
              {loading ? 'Signing in...' : <><span>Sign in</span><ArrowRight size={15} /></>}
            </button>
          </form>
        </div>

        <p style={{ textAlign:'center', marginTop:20, fontSize:14, color:'var(--muted)' }}>
          No account? <Link to="/signup" style={{ color:'var(--accent2)', fontWeight:600, textDecoration:'none' }}>Create one free</Link>
        </p>
      </div>
    </div>
  );
}